export const SET_MENUS = 'SET_MENUS';
export const GET_MENUS_REQUEST = 'GET_MENUS';

export const getMenusRequest = (onComplete) => ({
  type: GET_MENUS_REQUEST,
  onComplete
});
